// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Qys","left":"styles_left__2_dtv"};